<div class="auth-box-w wider centered mt-5">
  <h3 class="auth-header">Email Verification</h3>

  <h5 *ngIf="message" class="text-success">{{ message }}</h5>
  <h5 *ngIf="error" class="text-danger">{{ error }}</h5>
</div>
